import React, { useState } from "react";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
// Importar sub-componentes
import BillingSearch from "./BillingSearch";
import BillingData from "./invoiceForm";
import BillingShowData from "./invoiceDetails";
// import BillingForm from "./views/BillingForm";
import CancelationBilling from "./cancelationBilling";
import ReportTemperature from "./reportTemperature";

function Billing() {
  // 1. Estado para controlar en qué paso del proceso estamos (Buscador vs Formulario)
  const [step, setStep] = useState("search"); // 'search' o 'details'

  // 2. Estado para los Tabs superiores (solo visibles en 'details')
  const [activeTab, setActiveTab] = useState("billing");

  // 3. Información de la guía cargada
  const [masterData, setMasterData] = useState(null);

  // Función para manejar la búsqueda exitosa
  const handleSearchSuccess = (data) => {
    setMasterData(data); 
    setStep("details");
    // Si el WS dice que ya existe factura, vamos a ver detalles, si no, al formulario
    setActiveTab(data.view === "showDetails" ? "view_invoice" : "billing");
  };

  // Caso B: Éxito al guardar factura (desde BillingForm/invoiceForm)
  const handleInvoiceCreated = (response) => {
    // Actualizamos masterData con la respuesta del guardado para tener el Folio, etc.
    setMasterData((prev) => ({
      ...prev,
      formData: response.data // Datos de la factura recién creada
    }));
    setActiveTab("view_invoice");
  };

  // Renderizado condicional centralizado
  const renderContent = () => {
    if (step === "search") {
      return <BillingSearch onSearchSuccess={handleSearchSuccess} />;
    }

    switch (activeTab) {
      case "billing":
        return (
          <BillingData
            masterNumber={masterData?.masterNumber}
            initialData={masterData?.formData}
            onInvoiceCreated={handleInvoiceCreated} // Callback para cambio de vista
          />
        );
      case "view_invoice":
        return (
          <BillingShowData 
            masterNumber={masterData?.masterNumber} 
            data={masterData?.formData} 
          />
        );
      case "cancelation":
        return <CancelationBilling />;
      case "temperature":
        return <ReportTemperature />;
      default:
        return <BillingSearch onSearchSuccess={handleSearchSuccess} />;
    }
  };

  

  return (
    <>
      <Helmet>
        <title>Horus | Búsqueda master</title>
      </Helmet>
      <ScrollToTop />
  
      <div className="container-fluid module-container">
        {/* Tabs */}
        {step === "details" && (
          <div className="d-flex gap-3 mb-4">
            <button
              onClick={() => setActiveTab("billing")}
              className="btnn"
              style={{
                backgroundColor: activeTab === "billing" ? "" : "#e0e0e0",
              }}
            >
              Facturación
            </button>
  
            <button
              onClick={() => setActiveTab("cancelation")}
              className="btnn"
              style={{
                backgroundColor: activeTab === "cancelation" ? "" : "#e0e0e0",
              }}
            >
              Cancelación
            </button>
  
            <button
              onClick={() => setActiveTab("temperature")}
              className="btnn"
              style={{
                backgroundColor: activeTab === "temperature" ? "" : "#e0e0e0",
              }}
            >
              Reporte Temp
            </button>
          </div>
        )}
  
        {/* Contenido */}
        <div className="module-content">
          {renderContent()}
        </div>
      </div>
    </>
  );
  
};

export default Billing;